import { apiClient } from '@/libs/api'
import { type ShipmentOrdersRequestQuery } from '@/libs/api/types'

export type ExportShipmentOrderRequest = {
  tenantKey: string
  query: ShipmentOrdersRequestQuery
}

export const exportShipmentOrders = async (
  { tenantKey, query }: ExportShipmentOrderRequest,
  signal?: AbortSignal
): Promise<Blob> => {
  const data = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.export.csv.$get({
      query,
      config: {
        signal
      }
    })
  return data
}
